<template>
  <div id="userManager">
    <div class="allSearch">
      <div style="align-items: flex-end" class="newSearch d_flex">
        <div style="white-space: normal;width: auto;">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="姓名" v-model="postData.name">
          </p>
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="机构" v-model="postData.instName">
          </p>
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="昵称" v-model="postData.nickName">
          </p>
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="OpenID" v-model="postData.nonHCPOpenID">
          </p>
          <p>
            <cander v-model="postData.beginRegTime" :className="'allInput'" placeholderName="注册时间 - 开始"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="postData.endRegTime" :minDate="postData.beginRegTime" :className="'allInput'" placeholderName="注册时间 - 结束"  class="d_i" style="vertical-align: middle"></cander>
          </p>
        </div>
        <div style="width: auto">
          <!-- <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>-->
          <button class="redButton" @click="getList(1)">
            搜索
          </button>
          <!-- <button @click="clearPostData" class="cancelButtonTwo">
            清空
          </button> -->
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <nav v-if="$childMenu.indexOf('导出') >= 0" class="m_b_10"><button class="redButtonTwo" @click="exportList()">导出</button></nav>
        <div style="overflow:auto; width: 100%;">
          <table cellspacing="0" class="allTable" :style="'width: 100%;'">
            <thead>
            <tr>
              <th>操作</th>
              <!-- <th>用户来源</th> -->
              <th>姓名</th>
              <th>机构</th>
              <th>注册时间</th>
              <th>昵称</th>
              <th>OpenID</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in myList" :key="index">
              <td width="1%" style="min-width:20px;max-width:210px;" >
                <div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <!--<li v-if="isAdmin" @click="delHcp(item.openId)">解绑</li>-->
                    <li v-if="$childMenu.indexOf('注销') >= 0" @click="delHcp(item.openId)">解绑</li>
                  </ul>
                </div>
              </td>
              <td width="2%" class="NoWrap" style="max-width: 50px;min-width:20px;" :title="item.name">{{item.name}}</td>
              <td width="3%" class="" style="max-width: 100px;min-width:20px;" :title="item.institution">{{item.institution}}</td>
              <td width="3%" class="NoWrap" style="max-width: 100px;min-width:20px;">{{item.createTime ? $commonJs.returnNewDate(item.createTime) : ''}}</td>
              <td width="3%" class="NoWrap" style="max-width: 100px;min-width:20px;" :title="item.nickName">{{item.nickName}}</td>
              <td width="5%" class="NoWrap" style="max-width: 150px;min-width:20px;" :title="item.openId">{{item.openId}}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'nonHCPList',
  data () {
    return {
      onSearch: false,
      showModel: false,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize,
        name: '',
        instName:'',
        nickName:'',
        nonHCPOpenID:'',        
        beginRegTime: '',
        endRegTime: ''
      },
      myList: [],
      appList: [],
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      showOther: false,
      isAdmin: JSON.parse(window.localStorage.getItem('isAdmin'))
    }
  },
  created () {
    console.log(this.isAdmin, 'isAdmin')
    if (this.appowner) {
      if (this.appowner.roles.indexOf('AppOwner') >= 0) {
        this.showOther = true
      }
    }
    this.getList(1)
  },
  methods: {
    exportList () {
      let that = this
      let url = ''
      let name = ''
      var xmlResquest = new XMLHttpRequest()
      const data = JSON.parse(JSON.stringify(this.postData))
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      url = this.$commonJs.returnQuery(process.env.config.baseUrl + '/api/hcp/exportNonHCPList', data)
      let params = {
        
      }
      axios.post(url,params, {responseType: "arraybuffer"}).then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'nonHCP列表.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    },
    clearPostData () {
      this.postData.name = ''
      this.postData.instName = ''
      this.postData.nickName = ''
      this.postData.nonHCPOpenID = ''
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      console.log(data, 'data')
      console.log(this.postData, 'this.postData')
      let url
      url = this.$commonJs.returnQuery('/api/hcp/queryNonHCP', data)
      this.$axiox.post(url).then(msg => {
        console.log(msg, 'msg')
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
    },
    returnStr(arr) {
      let str = ''
      if (arr && arr.length > 0) {
        let newArr = arr.map(item => item.name)
        str = newArr.join(',')
      }
      return str
    },
    delHcp (openId) {
      this.$commonJs.doubleComfirm({
        content: '您是否确认解绑？',
        successFun: () => {
          this.$axiox.del(`/api/hcp/DelNonHcpCustomer?openId=${openId}&channel=P`).then(res => {
            console.log(res, 'delHcp')
            if (res == 'True') {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '您已解绑成功',
                stayTime: 5
              })
              // 获取HCP列表
              this.getList(1)
            }
          })
        },
        errorFun: err => {
        }
      })
    },
  }
}
</script>

<style scoped>
  #modelSwitah{
    padding:0 10px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/userManager/nonHCPList.vue